import React, { useState, useEffect } from 'react'
import HeroBgAnimation from '../HeroBgAnimation'
import { HeroContainer, HeroBg, HeroLeftContainer, Img, HeroRightContainer, HeroInnerContainer, TextLoop, Title, Span, SubTitle,SocialMediaIcons,SocialMediaIcon, ResumeButton } from './HeroStyle'
import HeroImg from '../../images/HeroImage.jpg'
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';

const HeroSection = () => {
    const [yearsOfExperience, setYearsOfExperience] = useState('');

    useEffect(() => {
        const calculateExperience = (startDate) => {
            const start = new Date(startDate);
            const now = new Date();
            const years = now.getFullYear() - start.getFullYear();
            const months = now.getMonth() - start.getMonth();
            return months < 0 || (months === 0 && now.getDate() < start.getDate()) ? years - 1 : years;
        };
        
        const years = calculateExperience('2021-12-27');
        const description = Bio.description.replace(/\d+\+ years/g, `${years}+ years`);
        setYearsOfExperience(description);
    }, []);

    return (
        <div id="about">
            <HeroContainer>
                <HeroBg>
                    <HeroBgAnimation />
                </HeroBg>
                <HeroInnerContainer >
                    <HeroLeftContainer id="Left">
                        <Title>Hi, I am <br /> {Bio.name}</Title>
                        <TextLoop>
                            I am a
                            <Span>
                                <Typewriter
                                    options={{
                                        strings: Bio.roles,
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </Span>
                        </TextLoop>
                        <SubTitle>{yearsOfExperience || Bio.description}</SubTitle>
                        <ResumeButton href={Bio.resume} target='display'>Check Resume</ResumeButton>
                    </HeroLeftContainer>

                    <HeroRightContainer id="Right">
                        <Img src={HeroImg} alt="hero-image" />
                    </HeroRightContainer>
                </HeroInnerContainer>

            </HeroContainer>
        </div>
    )
}

export default HeroSection